/**
 * University of Arizona tenant configuration
 */

import type { TenantConfig } from '../types'
import { defaultFeatures, defaultSupport } from './base'

const arizonaConfig: TenantConfig = {
  tenant: 'arizona',

  branding: {
    name: 'University of Arizona',
    shortName: 'the University of Arizona',
    logo: 'logos/arizona.png',
    footerLogo: 'logos/arizona-footer.png',
    favicon: 'favicon.ico',
    primaryColor: '#CC0033',    // Arizona Red
    secondaryColor: '#003366',  // Arizona Blue
    accentColors: ['#8B0015'],  // Dark red
    theme: 'dark',
    heroImage: 'backgrounds/arizona.jpg',
    headerText: 'Arizona Transfer Planner',
  },

  features: {
    ...defaultFeatures,
    minorSelection: true,       // Arizona has minor selection
    twoToFourYear: true,        // Arizona has 2-to-4 year workflow
    savedPlans: true,           // Enable login/logout
  },

  dataSource: 'arizona-s3',     // Uses CSV/S3 path

  institutions: {
    destination: {
      id: 4036,
      name: 'University of Arizona',
    },
    startingSchools: [
      { id: 3056, name: 'Pima Community College', slug: 'pima-community-college', enabled: true },
      { id: 4657, name: 'Maricopa Community College', slug: 'maricopa-community-college', enabled: false },
      { id: 4658, name: 'Eastern Arizona College', slug: 'eastern-arizona-college', enabled: false },
    ],
  },

  support: {
    ...defaultSupport,
    contactEmail: 'transfer@arizona.edu',
    helpUrl: 'https://transfer.arizona.edu',
  },

  content: {
    heroTitle: 'Making transfer credits count',
    heroCTAText: 'TRANSFER EVALUATION',
    nav: {
      transferLabel: '',
    },
    footer: {
      addressLine: 'University of Arizona | 1401 E University Blvd, Tucson, AZ 85721',
      contactLine: 'Phone: (520) 621-2211',
      copyrightLine: '© 2026 Arizona Board of Regents',
    },
  },
}

export default arizonaConfig
